import { pick } from 'shared/utils/objectUtils'
import { ProductType } from 'views/utils/propTypes/api'

export const ProductVariantType = pick(ProductType, [
  'id',
  'unit',
  'unitQuantityString',
  'canonicalURL',
  'discount',
  'stockStatus',
  'followUpProductCode',
])
